import { API_V1_URL } from './config';

export type CampItemResponse = {
  id: number;
  name: string;
  age_from: number;
  age_to: number;
  start_date: string;
  end_date: string;
  dates: string[];
  capacity: number;
  time_range: [string, string];
};

export async function fetchCampsForLocation(locationId: number) {
  const response = await fetch(`${API_V1_URL}locations/${locationId}/camps`);
  if (response.ok) {
    return (await response.json()) as CampItemResponse[];
  }
  return null;
}
